import { Header } from 'components/atoms/Header/Header';
import { LANGUAGE_SETTINGS } from 'en';
import './_RolandPlan.scss';
import { Paragraph } from 'components/atoms/Paragraph/Paragraph';

export const RolandPlan = () => (
  <section className='roland-plan'>
    <Header text={LANGUAGE_SETTINGS.rolandCreate} />
    <Header text={LANGUAGE_SETTINGS.rolandCreateTitle} />
    <Paragraph text={LANGUAGE_SETTINGS.rolandIncludesOne} />
    <Paragraph text={LANGUAGE_SETTINGS.rolandIncludesTwo} />
    <Paragraph text={LANGUAGE_SETTINGS.rolandIncludesThree} />
    <Paragraph text={LANGUAGE_SETTINGS.rolandIncludesFour} />
  </section>
);
